import React, { useEffect, useState } from "react";

/* -------- framework elements -------- */
import { projectTiles } from '../../../utils/items';
import { dictionary } from "../../../utils/dictionary";
/* -------- ------- -------- */


/* -------- packages -------- */
import { Link, useNavigate } from "react-router-dom";
import {
    Badge,
    Card,
    CardBody,
    Col,
    UncontrolledTooltip,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/* -------- ------- -------- */

/* -------- components -------- */
import DeleteModal from "../DeleteModal";
/* -------- ------- -------- */


/* -------- intern functions -------- */
import { deleteProjectRequest, fetchConfigurationsRequest, updateProjectRequest } from "../../../store/actions";
/* -------- ------- -------- */


export default function Tuiles({ projects, editFunction }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isModalOpen, setModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [projectToDelete, setProjectToDelete] = useState(null);

    useEffect(() => {
        dispatch(fetchConfigurationsRequest());
    }, [dispatch]);

    function getImage(projectId) {
        const index = (projectId - 1) % projectTiles.length;
        return projectTiles[index].path;
    }

    const handleDeleteProject = (projectId) => {
        setProjectToDelete(projectId);
        setDeleteModalOpen(true);
    }

    const handleNewConfiguration = (projectId) => {
        navigate('/configurations/new', {
            state: {
                projectId: projectId,
                isNewConfig: true
            }
        });
    }

    const handleChangeStatus = (project) => {

        let values = {};

        if (project.status === dictionary.projProject.statusFinished) {
            values = {
                status: dictionary.projProject.statusPending,
                lib: project.lib,
                id: project.id
            }

            return dispatch(updateProjectRequest(values));
        }

        values = {
            status: dictionary.projProject.statusFinished,
            lib: project.lib,
            id: project.id
        }
        dispatch(updateProjectRequest(values));
    }
    
    const confirmDelete = () => {
        if (projectToDelete) {
            dispatch(deleteProjectRequest(projectToDelete));
            setDeleteModalOpen(false);
            setProjectToDelete(null);
        }
    };

    const cancelDelete = () => {
        setDeleteModalOpen(false);
        setProjectToDelete(null);
    };

    return (
        <>
            <DeleteModal
                show={deleteModalOpen}
                onDeleteClick={confirmDelete}
                onCloseClick={cancelDelete}
                customMessage={t('deleteProjectMessage')}
            />
            {projects?.map((project, key) => {

                return (

                    <Col xl={3} lg={5} className="d-flex align-items-center justify-content-center p-0" key={key}>
                        <div className={"tuilsBody" + (project.status === dictionary.projProject.statusFinished ? " projectClosed" : project.status === dictionary.projProject.statusPending ? " projectOpen" : " ")}>
                            <div className="tuilsHeader">
                                <svg className="tuilsSvgIcon" focusable="false" aria-hidden="true" viewBox="0 0 144 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="m111.34 23.88c-10.62-10.46-18.5-23.88-38.74-23.88h-1.2c-20.24 0-28.12 13.42-38.74 23.88-7.72 9.64-19.44 11.74-32.66 12.12v26h144v-26c-13.22-.38-24.94-2.48-32.66-12.12z" fill="currentColor" fillRule="evenodd"></path>
                                </svg>
                                <div className="tuilsAvatar">
                                    <div className={"avatarImage" + (project.status === dictionary.projProject.statusFinished ? " projectClosed" : project.status === dictionary.projProject.statusPending ? " projectOpen" : " ")}
                                        id={"projStatusIcon_" + project.id}>
                                        {(project.ProjConfigurations && project.ProjConfigurations.length > 0) ? /* display a conditional icon if project contains configuration or not */
                                            (
                                                <span className="mdi mdi-folder-open-outline folderIcon"></span>
                                            ) : (
                                                <span className="mdi mdi-folder-outline folderIcon"></span>
                                            )
                                        }
                                        <UncontrolledTooltip
                                            transition={{ timeout: 300 }}
                                            placement="top"
                                            fade={false}
                                            target={'projStatusIcon_' + project.id}
                                        >
                                            {(project.status === dictionary.projProject.statusFinished) ? t('projectClosed') : t('projectOpen')}
                                        </UncontrolledTooltip>
                                    </div>
                                </div>
                                <span className="tuilsHeaderBgContainer">
                                    <span className="tuilsHeaderBgOverlay"></span>
                                    <img src={getImage(project.id)} className="headerImage" />
                                </span>
                            </div>
                            <div className="tuilsProjectInfoContainer">
                                <span
                                    className="tuilsProjectLib"
                                    style={{ cursor: "pointer", textDecoration: "underline" }}
                                    onClick={() => navigate('/configurations', { state: { projectName: project.lib } })}
                                >
                                    {project.lib}
                                </span>
                            </div>
                            {project.userFullName && (
                                <div className="tuilsCreatorInfo" style={{ paddingBottom: "10px", textAlign: "center" }}>
                                    <p className="text-muted mb-0" style={{ fontSize: "0.55rem" }}>
                                        {t('createdBy')}: <strong>{project.company}</strong>
                                    </p>
                                </div>
                            )}

                            <div className="avatar-group">
                                {project.ProjConfigurations?.length ? <p>{t('myConfigs')}: {project.ProjConfigurations.length}</p> : <p>{t('noConfig')}</p>}
                                <div className="configBubbles">

                                    {project.ProjConfigurations?.length > 0 ? (
                                        (() => {
                                            const configs = project.ProjConfigurations;
                                            const displayConfigs = configs.slice(0, 4);
                                            const hasMore = configs.length > 4;

                                            return (
                                                <>
                                                    {displayConfigs.map((config) => (
                                                        <div
                                                            className={
                                                                "avatar-group-item " +
                                                                (config.status === 'QUOTE_OK' ? "bg-confirmed" :
                                                                    config.status === 'PENDING' ? "bg-inProgress" :
                                                                        config.status === 'QUOTE_EXPIRED' ? "bg-quoteExpired" :
                                                                            config.status === 'DONE' ? "bg-secondary" : "")
                                                            }
                                                            key={config.id}
                                                        >
                                                            <Link to="#" className="d-inline-block" id={"member" + config.id}>
                                                                <span className="mdi mdi-file-cog-outline rounded-circle avatar-xs"></span>
                                                                <UncontrolledTooltip
                                                                    transition={{ timeout: 300 }}
                                                                    placement="top"
                                                                    fade={false}
                                                                    target={"member" + config.id}
                                                                >
                                                                    [{t(config.status)}] {config.lib}
                                                                </UncontrolledTooltip>
                                                            </Link>
                                                        </div>
                                                    ))}
                                                    {hasMore && (
                                                        <span
                                                            className="config-bubbles-dots"
                                                            style={{ padding: "0 0 0 5px", fontWeight: "bold" }}
                                                        >
                                                            ...
                                                        </span>
                                                    )}
                                                </>
                                            );
                                        })()
                                    ) : (
                                        <div className={"avatar-group-item emptyConfig"}>
                                            <Link>
                                                <span className={"mdi mdi-file-cog-outline rounded-circle avatar-xs "}></span>
                                            </Link>
                                        </div>
                                    )
                                    }
                                </div>
                            </div>

                            <hr className="footerSpacer" />

                            <div className="tuilsFooter">
                                <div className="tuilesDate" id="dueDate">
                                    <p>{t('updatedAt')}</p>
                                    <i className="bx bx-calendar me-1" /> {moment(project.updatedAt).format('DD-MM-YYYY')}
                                </div>
                                <div className="tuilsActionIconContainer deleteEditIcons">
                                    {
                                        project.status === dictionary.projProject.statusFinished ? (
                                            null
                                        ) : (
                                            <>
                                                <i id={"tuilsBtnAddConfig" + project.id} className="mdi mdi-plus-circle projectOpen" onClick={() => { handleNewConfiguration(project.id) }} />
                                                <UncontrolledTooltip
                                                    transition={{ timeout: 300 }}
                                                    placement="top"
                                                    fade={false}
                                                    target={'tuilsBtnAddConfig' + project.id}
                                                >
                                                    {t('newConfiguration')}
                                                </UncontrolledTooltip>
                                            </>
                                        )
                                    }
                                    {project.status !== dictionary.projProject.statusFinished && (
                                        <>
                                            <i
                                                id={"tuilsBtnEdit" + project.id}
                                                className={"mdi mdi-square-edit-outline editIcon"}
                                                onClick={() => {editFunction(project.id, project.lib, project.status) }}
                                            />
                                            <UncontrolledTooltip
                                                transition={{ timeout: 300 }}
                                                placement="top"
                                                fade={false}
                                                target={'tuilsBtnEdit' + project.id}
                                            >
                                                {t('editProject')}
                                            </UncontrolledTooltip>
                                        </>
                                    )}
                                    <i
                                        id={"tuilsBtnChangeStatus" + project.id}
                                        className={"mdi mdi mdi-list-status " + (project.status === dictionary.projProject.statusFinished ? "projectOpen" : "projectClosed")}
                                        onClick={() => { handleChangeStatus(project) }} />
                                    <i
                                        id={"tuilsBtnDelete" + project.id}
                                        className="mdi mdi-trash-can-outline deleteIcon"
                                        onClick={() => { handleDeleteProject(project.id) }} />

                                    <UncontrolledTooltip
                                        fade={false}
                                        transition={{ timeout: 300 }}
                                        placement="top"
                                        target={'tuilsBtnChangeStatus' + project.id}
                                    >
                                        {t('changeStatus')}
                                    </UncontrolledTooltip>
                                    <UncontrolledTooltip
                                        transition={{ timeout: 300 }}
                                        placement="top"
                                        fade={false}
                                        target={'tuilsBtnDelete' + project.id}
                                    >
                                        {t('delete')}
                                    </UncontrolledTooltip>
                                </div>
                            </div>
                        </div>
                    </Col>
                )
            }
            )}
        </>
    );
};